import {authGuard} from './authGuard'

export const routes = [
    {
        ////
      path: '/',
      name: 'Main',
      component: () => import('../views/empty/Auth.vue'),
      children: [
        // { path: '/', component: () => import('../views/components/Body.vue')},
        // { path: '/', component: () => import('../views/components/Categories.vue')},
        { path: '/categories/:id', component: () => import('../views/components/Categories.vue')},
        { path: '/foods/:id',  component: () => import('../views/components/Body.vue')},
        // { path: '/basket', component: () => import('../views/components/Basket.vue')},
        { path: '/category/:category/product/:id', component: () => import('../views/components/Product.vue')},
      
      ]
    },
    {
        path: '/basket',
        name: 'Basket',
        component: () => import('../views/components/Basket.vue'),
        // meta: {layout: 'not_authorized', requiresAuth: false},

    },
    {
      path: '/login',
      name: 'Auth',
      component: () => import('../views/empty/Auth.vue'),
      // meta: {layout: 'not_authorized', requiresAuth: false},
    },
    {
        path: '/user/login',
        name: 'Auth',
        component: () => import('../views/empty/UserAuth.vue'),
        // meta: {layout: 'not_authorized', requiresAuth: false},
    },
    {
        path: '/user',
        name: 'Auth',
        component: () => import('../views/components/User.vue'),
        // meta: {layout: 'not_authorized', requiresAuth: false},
    },
    {
      path: '/admin',
      name: 'Admin',
      component: () => import('../views/empty/Admin'),
        children: [

            { path: '/orders', component: () => import('../views/components/ProductOrders.vue')},
            { path: '/sliders', component: () => import('../views/components/ProductSlider.vue')},
            { path: '', component: () => import('../views/components/ProductCategory.vue')},
            { path: '/products', component: () => import('../views/components/ProductSettings.vue')},
            { path: '/list-products', component: () => import('../views/components/ListProducts.vue')},
            { path: '/set/category', component: () => import('../views/components/setCategory.vue')},
            { path: '/bonuses', component: () => import('../views/components/Bonuses.vue')},

        ]
      // beforeEnter: authGuard
    },
    {
      path: '/basket',
      name: 'basket',
      component: () => import('../views/components/Basket.vue'),
      meta: {layout: 'not_authorized', requiresAuth: false},
      beforeEnter: authGuard
    },
    {
        path: '/menu',
        name: 'menu',
        component: () => import('../views/components/Menu.vue'),
        meta: {layout: 'not_authorized', requiresAuth: false},
        beforeEnter: authGuard
    },
    {
        path: '/fastfood',
        name: 'menu',
        component: () => import('../views/components/FastFood.vue'),
        meta: {layout: 'not_authorized', requiresAuth: false},
        beforeEnter: authGuard
    },

    {
      path: '*',
      name: '404',
      component: () => import('../views/cabinet/404.vue'),
    },
]